(() => {
  'use strict';
  const init = root => {
    if (root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const photos = [...root.querySelectorAll('[data-photo-open]')];
    const dialog = root.querySelector('[data-photo-dialog]');
    const full = root.querySelector('[data-photo-full]');
    const counter = root.querySelector('[data-photo-count]');
    if (!photos.length || !dialog || !full) return;
    let current = 0;
    let trigger = null;
    const show = index => {
      current = (index + photos.length) % photos.length;
      const image = photos[current].querySelector('img');
      if (!image) return;
      full.src = image.currentSrc || image.src;
      full.alt = image.alt;
      if (counter) counter.textContent = (current + 1) + ' / ' + photos.length;
    };
    photos.forEach((button, index) => button.addEventListener('click', () => {
      trigger = button;
      show(index);
      dialog.showModal();
      document.documentElement.classList.add('hr-photo-open');
    }));
    root.querySelector('[data-photo-close]')?.addEventListener('click', () => dialog.close());
    root.querySelector('[data-photo-prev]')?.addEventListener('click', () => show(current - 1));
    root.querySelector('[data-photo-next]')?.addEventListener('click', () => show(current + 1));
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('hr-photo-open');
      trigger?.focus({ preventScroll: true });
    });
    const section = root.closest('[data-outfit-detail]');
    const panel = section?.querySelector('.hr-outfit-product-shop');
    if (panel && window.ResizeObserver) {
      const observer = new ResizeObserver(() => section.style.setProperty('--outfit-panel-height', panel.getBoundingClientRect().height + 'px'));
      observer.observe(panel);
    }
  };
  const start = scope => {
    if (scope.matches?.('[data-editorial-gallery]')) init(scope);
    scope.querySelectorAll?.('[data-editorial-gallery]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document)); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
